import React from 'react'

const VirtualFooter = ({item}) => {
  return (
    <>
     <footer className="bg-[#1C2836] py-[20px] text-white">
        <div className="max-w-[1280px] mx-auto px-4">
          {/* Top Footer */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6 p-2 bg-[#E07436]">
            {/* Logo */}
            <div className="flex items-center gap-2">
              <img src={item?.org_logo} alt="logo" className="h-10 w-auto" />
            </div>

            {/* Nav Links */}
            <div className="flex flex-wrap items-center justify-center gap-5 text-[14px] font-medium">
              {item?.pages?.map((item, i) => (
                <a
                  key={i}
                  href={item?.url}
                  className="hover:text-orange-200 transition"
                  target="_blank"
                  rel="noreferrer"
                >
                  {item?.page_name}
                </a>
              ))}
            </div>
            <div></div>
          </div>

          {/* Bottom Footer */}
          <div className="flex items-center justify-center flex-col sm:flex-row gap-4 mt-[10px] pt-3 border-t border-white/30 text-[13px]">
            <span>{item?.copyright_text}</span>
            <span className="hidden sm:inline-block">||</span>
            <span>Powered by virtualsevak.com</span>
          </div>
        </div>
      </footer>
    </>
  )
}

export default VirtualFooter